// extracted by mini-css-extract-plugin
export var createdDate = "_ik-1";
export var divider = "_ik-2";
export var headerDivider = "_ik-3";
export var messagesCard = "_ik-0";
export var messagesContainer = "_ik-7";
export var messagesContainerWrapper = "_ik-4";
export var pointerCapturingButtonBoxes = "_ik-a";
export var showLeftPanelButton = "_ik-9";
export var showMoreButton = "_ik-c";
export var showMoreButtonContainer = "_ik-b";
export var summaryTitle = "_ik-6";
export var systemMessageCardWrapper = "_ik-d";
export var topButtons = "_ik-8";
export var withPadding = "_ik-5";